module.exports = __webpack_public_path__ + "static/telecom-vs-messengers-3a4e118467104e26d0f08bbf2d818472.webp";